import { uuidv7 } from '@st/util/uuidv7'
import { Clock, Context, Effect, Layer, Ref } from 'effect'

type IdGeneratorService = {
  readonly generate: Effect.Effect<string>
}

export class IdGenerator extends Context.Service<IdGenerator, IdGeneratorService>()(
  'IdGenerator'
) {}

const MAX_SEQUENCE = 1 << 18

type GeneratorState = {
  timestampMs: number
  sequence: number
}

function nextGeneratorState(now: number, state: GeneratorState): GeneratorState {
  if (now > state.timestampMs) return { timestampMs: now, sequence: 0 }

  const sequence = state.sequence + 1
  if (sequence < MAX_SEQUENCE) return { ...state, sequence }
  return { timestampMs: state.timestampMs + 1, sequence: 0 }
}

const secureRandomBytes = Effect.sync(() => crypto.getRandomValues(new Uint8Array(7)))

export const idGeneratorLiveLayer = Layer.effect(
  IdGenerator,
  Effect.gen(function* () {
    const generatorState = yield* Ref.make<GeneratorState>({ timestampMs: 0, sequence: 0 })

    return {
      generate: Effect.gen(function* () {
        const now = yield* Clock.currentTimeMillis
        const state = yield* Ref.modify(generatorState, (previous) => {
          const next = nextGeneratorState(now, previous)
          return [next, next]
        })
        const randomBytes = yield* secureRandomBytes
        return uuidv7({ ...state, randomBytes })
      })
    }
  })
)
